<template lang="html">
	<div class="custom-select multi" :class="{solo: solo}">
		<div class="selected" @click="display()">
			<div class="ctn-tags row" v-if="selected.length > 0">
				<div class="tag" v-for="(tag, key) in selected" v-bind:key="key" @click.stop="remove(key)">
					{{ displayItem(tag) }} <span class="delete row"><span>x</span></span>
				</div>
			</div>
			<div class="no-tags" v-else>
				&nbsp;
			</div>
			<span class="icon-arrow-full-down" :class="{deploy: show}"></span>
		</div>
		<div class="items" v-if="show">
			<div class="item" v-for="(item, key) in list" :class="{active: isSelected(key)}" v-bind:key="key" @click="setSelect(key)">
				{{ displayItem(item) }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'custom-multiselect',
	props: ['list', 'values', 'solo', 'object', 'getter'],
	data () {
		return {
			selected: [],
			show: false
		}
	},
	mounted () {
		if (this.values) {
			this.selected = this.values
		}
	},
	methods: {
		isSelected (key) {
			return (this.selected.indexOf(this.list[key]) !== -1)
		},
		setSelect (key) {
			if (this.selected.indexOf(this.list[key]) !== -1) {
				this.selected.splice(this.selected.indexOf(this.list[key]), 1)
			} else {
				this.selected.push(this.list[key])
			}
			this.$emit('change', this.selected)
		},
		display () {
			this.show = !this.show
			if (this.show) {
				window.setTimeout(() => { window.addEventListener('click', this.checkClick) }, 10)
			}
		},
		checkClick (e) {
			this.show = !this.show
			window.removeEventListener('click', this.checkClick)
		},
		remove (e) {
			this.selected.splice(e, 1)
		},
		displayItem (item) {
			if (this.object) {
				return item[this.getter]
			} else {
				return item
			}
		}
	},
	watch: {
		values (data) {
			if (data) {
				this.selected = data
			}
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CustomMultiselect.vue?2fa215a2